/**
 * This class offers a Promise-like interface but replaces `then` with `subscribe`.
 * The function passed into subscribe will then be called each time new data is available.
 * The onResult fn will also be given a `final` param in case the calling code needs to know
 * if the final chunk of data has been received.
 */
export class Stream {
    constructor(initialiser) {
        Object.defineProperty(this, "subscribed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "onResult", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        initialiser((val, final) => {
            if (this.onResult) {
                this.onResult(val, final);
            }
            if (final && this.onEnd) {
                this.onEnd();
            }
        }, (reason) => {
            if (this.onError) {
                this.onError(reason);
            }
        });
    }
    subscribe(subscription) {
        if (this.subscribed) {
            throw new Error("Already subscribed");
        }
        this.subscribed = true;
        this.onResult = subscription.onResult;
        this.onError = subscription.onError;
        this.onEnd = subscription.onEnd;
    }
}
